module.exports = __webpack_public_path__ + "img/th_150-70.1fed478c.jpg";